import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { AdminFeatureFlag, AdminFeatureFlags } from 'containers'

export const AdminFeatureFlagsRouter = () => {
  return (
    <Routes>
      <Route path="/:id" element={<AdminFeatureFlag />} />
      <Route path="/" element={<AdminFeatureFlags />} />
    </Routes>
  )
}
